import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import {User} from 'main/stores/users';

class AnnouncementReaction extends DomainObject {
  id;
  emojiKey;
  user;

  _relations = {
    user: User
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      emojiKey: observable,
      user: observable
    });

    this.merge(other);
  }
}

export default AnnouncementReaction;
